// Allows to show selected options when the current filter returns an empty set not allowing data-based filters to gather any options to display
export default {
  methods: {
    getSelectFilterValue (key) {
      const dataBasedOptions = this.columnValueList(key)
      const orphanedOptions = this.filters[key].data.filter(option => !dataBasedOptions.includes(option))
      return [...orphanedOptions, ...this.columnValueList(key)]
    },
  }
}
